export default () => {

 /** @type {HTMLDivElement} */
 var Images=window['PhotoContainer']
 var is360 = Images.dataset['is360']!=void 0
 // console.log({is360})

 class _Images {
  constructor() {
   Images.addEventListener('pointerdown',this.atTouchStart.bind(this))
   // if(!is360) {
   Images.addEventListener('pointerup',this.atTouchEnd.bind(this))
   Images.addEventListener('pointercancel',this.atTouchEnd.bind(this))
   // }
   Images.addEventListener('pointermove',this.atTouchMove.bind(this))
   this._active=1
   this._newActive=-1
   this.padding=parseInt(getComputedStyle(Images.offsetParent,null).getPropertyValue('padding-left'))
  }
  atTouchStart(ev){
   ev.preventDefault()
   ev.stopImmediatePropagation()

   Images.setPointerCapture(ev.pointerId)

   // console.log('touch start')

   if(!this._active) return
   if(this._moving) return
   let start={}
   start.x=ev.pageX //ev.touches[0].pageX
   start.y=ev.pageY //ev.touches[0].pageY
   start.time=Date.now()
   this._start=start
   // const{asIImageSliderTouchscreen:{asIImageSliderDisplay:{
   //  Images:Images,
   // }}}=this
   this._originalScroll=Images.scrollLeft
  } // at touch cancel
  applyScroll(currentScroll,_active) {
   var{_originalScroll}=this
   if(currentScroll>_originalScroll) {
    const nextImage=Images.children[_active]
    if(is360) {
     this.skipToImage(nextImage)
    }else{
     this.scrollToImageRight(nextImage)
    }
    this._active=_active+1
    makeThumbActiveAt(this._active-1)
   }else if(currentScroll<_originalScroll){
    const prevImage=Images.children[_active-2]
    if(is360) {
     this.skipToImage(prevImage)
    }else {
     this.scrollToImageLeft(prevImage)
    }
    this._active=_active-1
    makeThumbActiveAt(this._active-1)
   }else{
    Images.scrollLeft=_originalScroll
   }
  }
  atTouchEnd(ev){
   // console.log('touch end')

   ev.preventDefault()
   ev.stopImmediatePropagation()

   if(!this._start) return

   const dt = Date.now() - this._start.time

   var dx = ev.pageX - this._start.x
   var dy = ev.pageY - this._start.y
   var distance = Math.sqrt(dx * dx + dy * dy)

   this._start=null

   if(dt<300 && distance<5) {
    showLargePhotos(photoHolder.dataset['current'])
    return
   }

   if(is360) {
    if(this._newActive != -1) {
     this._active=this._newActive
     this._newActive = -1
    }
    return
   }

   const{_originalScroll:_originalScroll,_active}=this
   const currentScroll=Images.scrollLeft
   this.applyScroll(currentScroll,_active)
  }
  skipToImageAt(index) {
   const{_active,_moving}=this
   if(_moving) return
   if(_active==index) return
   const img=Images.children[index-1]
   const d=Math.abs(index-_active)
   if(_active<index) this.skipToImage(img,d)
   else this.skipToImage(img,d)
   this._active=index
  }
  scrollToImageAt(index) {
   const{_active,_moving}=this
   if(_moving) return
   if(_active==index) return
   const img=Images.children[index-1]
   const d=Math.abs(index-_active)
   if(_active<index) this.scrollToImageRight(img,d)
   else this.scrollToImageLeft(img,d)
   this._active=index
   // const i=[...Images.children].indexOf(image)
   // console.log(index,_active)
  }
  skipToImage(image) {
   Images.scrollLeft=image.offsetLeft-this.padding
   if(is360) {
    for(var img of Images.children) {
     img.style.opacity = 0
    }
    image.style.opacity = 1
   }
  }
  scrollToImageRight(nextImage,d=1) {
   // console.log('move to the next image',next,nextImage,nextImage.offsetLeft)
   this._moving=true
   const mv=()=>{
    Images.scrollLeft+=15*d
    if(Images.scrollLeft<nextImage.offsetLeft-this.padding) {
     requestAnimationFrame(mv)
    }else{
     Images.scrollLeft=nextImage.offsetLeft-this.padding
     this._moving=false
    }
   }
   requestAnimationFrame(mv)
  }
  scrollToImageLeft(prevImage,d=1) {
   this._moving=true
   const mv=()=>{
    Images.scrollLeft-=15*d
    if(Images.scrollLeft>Math.max(prevImage.offsetLeft-this.padding,0)) {
     requestAnimationFrame(mv)
    }else{
     Images.scrollLeft=prevImage.offsetLeft-this.padding
     this._moving=false
    }
   }
   requestAnimationFrame(mv)
  }
  atTouchMove(ev){
   ev.preventDefault()
   ev.stopImmediatePropagation()
   // console.log(this._moving)
   // if(!this._moving) return
   if(!this._start) return

   // const[{pageX:pageX}]=ev.touches
   const{pageX:pageX}=ev
   const{x}=this._start
   const dx=pageX-x
   this._dx=dx
   // console.log('touch move',{dx})

   // console.log(dx)
   if(is360) {
    var newActiveI
    var skip = Math.floor(Math.abs(dx) / 20) % Images.children.length
    if(dx>0) {
     newActiveI = (this._active - 1 + skip) % Images.children.length
    }else {
     newActiveI = (this._active - 1 - skip + Images.children.length) % Images.children.length
    }
    var img = Images.children[newActiveI]
    // if(!img) debugger
    this.skipToImage(img)
    makeThumbActive(img.dataset['id'])
    this._newActive = newActiveI + 1
    // this.applyScroll(currentScroll,this._active)
    // something else
   }else{
    Images.scrollLeft=this._originalScroll-dx
   }
   // scroll the pages container in that direction
   // console.log(pageX,x,pageY,y)
  }
 }

 const images=new _Images()

 /**@type {HTMLDivElement}*/
 const photoHolder=document.getElementById('PhotoHolder')
 // /**@type {HTMLDivElement}*/
 // const photoContainer=document.getElementById('PhotoContainer')
 /** @type {!Array<HTMLDivElement>} */
 const thumbs = [...document.querySelectorAll('[data-thumb]')]
 // const thumbs=thumbs.map(({parentElement})=>{
 //  return parentElement
 // })
 let i=0
 function makeThumbActiveAt(index) {
  if(index<0) index = 0
  const thumb=thumbs[index]
  const img = thumb.querySelector('img')
  removeThumbsActive()
  img.classList.add('ThumbBgActive')

  const id=img.dataset['photoId']
  photoHolder.dataset['current']=id
 }
 function makeThumbActive(id) {
  const thumb=thumbs.find(function(t){
   return t.dataset['thumb']==id
  })
  if(!thumb) return
  const img = thumb.querySelector('img')
  removeThumbsActive()
  img.classList.add('ThumbBgActive')

  const id1=img.dataset['photoId']
  photoHolder.dataset['current']=id1
 }

 for(const thumb of thumbs) {
  i++
  // const div=_img.parentElement
  // ThumbBgActive
  const j=i
  const id=thumb.dataset['thumb']
  thumb.addEventListener('click',()=>{
   if(images._moving) return
   if(is360) {
    var img=[...Images.children].find((img)=>{
     return img.dataset['id']==id
    })
    var _active = [...Images.children].indexOf(img) + 1
    images._active = _active
    images.skipToImage(img)
   }else {
    images.scrollToImageAt(j)
   }
   makeThumbActive(id)
  })
 }
 function removeThumbsActive(except) {
  for (const parentElement of thumbs) {
   const img = parentElement.querySelector('img')
   // if(img==except) return
   img.classList.remove('ThumbBgActive')
  }
 }

 function showLargePhotos(id) {
  LargePhotos.style.display=''
  for(const largePhoto of allLargePhotos) {
   if(largePhoto.dataset['id']==id) {
    largePhoto.style.display=''
    break
   }
   // largePhoto.style.setProperty('display','none','important')
  }
 }
 function hideLargePhotos() {
  LargePhotos.style.setProperty('display','none','important')
  // LargePhotos.style.display='none'
  for(const largePhoto of allLargePhotos) {
   largePhoto.style.setProperty('display','none','important')
  }
 }

 const LargePhotos=document.getElementById('LargePhotos')
 const CloseBtn=LargePhotos.querySelector('.CloseBtn')
 const allLargePhotos=LargePhotos.querySelectorAll('.LargePhoto')

 CloseBtn.addEventListener('click',() =>{
  hideLargePhotos()
 })

 // Images.addEventListener('click',()=>{
 //  showLargePhotos(photoHolder.dataset['current'])
 // })
 // if(photoHolder) {photoHolder.addEventListener('click',()=>{
 //  // which photo is currently being shown?
 //  showLargePhotos(photoHolder.dataset['current'])
 // })}else {
 //  // not a photo holder
 // }
 window.addEventListener('keydown',(e)=>{
  if(e.key=='Escape') {
   hideLargePhotos()
  }
  // console.log(123,e.key)
 })
}